<bd-toast-message></bd-toast-message>

<router-outlet></router-outlet>
<div ui-view></div>

<div *ngIf="pageLoadingService.isLoading$ | async" id="loadingSpinner">
    <div class="global-loading-spinner__body">
        <span class="global-loading-spinner__spinner"></span>
        <div class="global-loading-spinner__text">Loading&hellip;</div>
    </div>
</div>
